import { InfoField } from '@occc-app/design-system';
import { ConstraintFragment } from '@occc/graphql';
import {
  FULFILLMENT_CHANNEL_LABELS,
  FulfillmentChannel,
  FulfillmentChannelValue,
} from '@occc/feat-constraints';

const CHANNEL_BY_CONSTRAINT_TYPE_NAME: Partial<
  Record<ConstraintFragment['__typename'], FulfillmentChannelValue>
> = {
  ConstraintOrderAheadOnly: FulfillmentChannel.OrderAheadOnly,
  ConstraintInStoreOnly: FulfillmentChannel.InStoreOnly,
};

export const FulfillmentChannelConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const channel = constraints
    .map(({ __typename }) => CHANNEL_BY_CONSTRAINT_TYPE_NAME[__typename])
    .find(Boolean);

  return (
    <InfoField label='Fulfillment Channel' value={channel && FULFILLMENT_CHANNEL_LABELS[channel]} />
  );
};
